<template>
  <div v-loading="!dataReady" class="profile">
    <section class="profile__header">
      <div class="profile__back global_pointer">
        <img @click.stop="back" :src="require('@/assets/imgs/profile/back.png')" />
      </div>
    </section>
    <div class="user">
      <img v-if="userInfo && userInfo.headImg"
        :src="userInfo.headImg.url"
        alt="头像"
      />
      <img v-else src="@/assets/imgs/logo.png" alt="">
      <div v-if="userInfo" class="user-detail">
        <span class="user-name">{{userInfo ? userInfo.userName : ''}}</span>
        <span class="user-level">{{userInfo ? lang == 'en' ?'level'+ userInfo.level.code : userInfo.level.description : ''}}</span>
      </div>
      <div v-else class="user-detail" @click="login">
        <span class="user-name">{{ $t('message.profile.loginNow') }}</span>
      </div>
    </div>
    <div class="order">
      <div class="header">
        <div class="left">{{ $t('message.profile.myOrder') }}</div>
        <div class="right global_pointer" @click="orderList(0)">
          <span>{{ $t('message.profile.viewAll') }}</span>
          <img :src="arrow" alt="" />
        </div>
      </div>
      <hr />
      <div class="items" >
        <div class="item global_pointer" @click="orderList(1)">
          <img :src="wallet" alt="" />
          <span>{{ $t('message.profile.unpayed') }}</span>
        </div>
        <div class="item global_pointer" @click="orderList(2)">
          <img :src="subs" alt="" />
          <span>{{ $t('message.profile.toBeDelivered') }}</span>
        </div>
        <div class="item global_pointer" @click="orderList(3)">
          <img :src="track" alt="" />
          <span>{{ $t('message.profile.ToBeReceived') }}</span>
        </div>
      </div>
    </div>
    <div class="extra-info">
      <div class="header">
        <div class="left">{{ $t('message.profile.myInfo') }}</div>
        <div class="right">
          <img :src="arrow" alt="" />
        </div>
      </div>
      <div class="items">
        <hr />
        <div class="item">
          <span>{{ $t('message.profile.userId') }}</span>
          <span>{{userInfo ? userInfo.userNum : ''}}</span>
        </div>
        <hr />
        <div v-if="userInfo && userInfo.mobile" class="item">
          <span>{{ $t('message.profile.phone') }}</span>
          <span>{{userInfo ? formatPhone(userInfo.mobile) : ''}}</span>
        </div>
        <div v-if="userInfo && userInfo.email" class="item">
          <span>{{ $t('message.profile.email') }}</span>
          <span>{{userInfo ? userInfo.email : ''}}</span>
        </div>
      </div>
    </div>
    <!-- <div class="back" @click="$router.replace({path: `/app/home/Live`})">&lt;&lt;TEMP BACK</div> -->
    <div class="logout global_pointer" v-if="hasLogin" @click="logout">{{ $t('message.profile.logout') }}</div>
    <div class="logout global_pointer" v-else @click="login">{{ $t('message.profile.login') }}</div>
    <Download v-if="showDownload" @close-download="closeDownload"/>
  </div>
</template>

<script>
import arrow from '@/assets/imgs/icon-arrow.png';
import wallet from '@/assets/imgs/profile/icon-wallet.png';
import track from '@/assets/imgs/profile/icon-track.png';
import subs from '@/assets/imgs/profile/icon-subs.png';
import Download from '@/components/profile/download.vue'
import api from '@/api/api_list';


export default {
  data() {
    return {
      arrow,
      wallet,
      track,
      subs,
      hasLogin: true,
      userInfo: null,
      showDownload: false,
      lang: this.$i18n.locale,
      dataReady: false
    };
  },
  components:{
    Download
  },
  created(){
    this.getUserInfo();
  },
  methods:{
    back() {
      this.$router.back(-1)
    },
    getUserInfo(){
      this.userInfo = this.$storage.get('user_info') || null

      if(!this.userInfo){
        this.hasLogin = false;

        // 唤起登录面板
        this.$isLogin( () => {
          this.loginSuccess();
        }, true);
      }else{
        // 用于验证当前账号是否被禁用 或 token是否失效 
        api.get_user_info();
      }
      this.dataReady = true
    },

    getUserInfoRemote(){
      api.get_user_info()
      .then(res=>{
        if(res.code === 0){
          this.userInfo = res.result.intgUser
          this.hasLogin = true
        }
      })
    },
    loginSuccess(){
      this.$toast(this.$t('message.profile.loginSuccess'));
      this.hasLogin = true;
      this.getUserInfo()
    },
    logout(){ 
      this.$storage.delete('user_info')
      this.$storage.delete('user_token')
      this.getUserInfo()
    },
    login(){
      this.getUserInfo()
    },
    closeDownload(){
      this.showDownload = false
    },
    openDownload(){
      this.showDownload = true
    },
    orderList(tabIndex){

          this.$isLogin(function () {
              this.$router.push({
              path: '/app/order_list',
              query: {
                  tabIndex
              }
          });
           }.bind(this));

      
    },
    formatPhone(phone){
      if(!phone) return ''
      else{
        let phoneArr = phone.split('')
        phoneArr.splice(3,4,'*','*','*','*')
        return phoneArr.join('')
      }
    }
  }
};
</script>

<style lang="less" scoped>
.profile {
  padding: 12px;
  background-color: #000000;
  box-sizing: border-box;
  &__back {
    box-sizing: border-box;
    text-align: left;
    img {
      width: 28px;
      height: 28px;
    }
  }
  hr {
    border: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    margin: 0;
    padding: 0;
  }
  & .user {
    display: flex;
    align-items: center;
    background: #1d1d1d;
    box-sizing: border-box;
    padding: 12px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    margin-bottom: 12px;
    & img {
      width: 60px;
      height: 60px;
      border-radius: 60px;
      margin-right: 12px;
    }
    &-detail {
      display: inline-flex;
      flex-direction: column;
      text-align: left;
      & .user-name {
        height: 28.99px;
        font-size: 21px;
        font-weight: 500;
        color: #ffffff;
        line-height: 28.99px;
      }
      & .user-level {
        width: fit-content;
        height: 16px;
        padding: 0 4px;
        font-size: 10px;
        color: #ffffff;
        line-height: 16px;
        background: linear-gradient(135deg, #222222 0%, #4f3208 100%);
        border-radius: 2px;
      }
    }
  }
  & .order {
    background: #1d1d1d;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    box-sizing: border-box;
    margin-bottom: 12px;
    & .items {
      display: flex;
      padding: 22px 0 13px;
      & .item {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        & img {
          width: 22px;
          height: 22px;
          margin-bottom: 4px;
        }
        & span {
          height: 17px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.6);
          line-height: 17px;
        }
      }
    }
  }
  & .header {
    display: flex;
    justify-content: space-between;
    padding: 12px;
    & .left {
      height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
    }
    & .right {
      line-height: 0;
      display: flex;
      align-items: center;
      & span {
        height: 17px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 17px;
      }
      & img {
        width: 14px;
        height: 14px;
      }
    }
  }
  & .extra-info {
    background: #1d1d1d;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    box-sizing: border-box;
    margin-bottom: 82px;
    & .items {
      & .item {
        height: 20px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 20px;
        padding: 12px;
        display: flex;
        justify-content: space-between;
        & span{
          min-width: 100px;
          text-align: left;
        }
      }
    }
  }
  & .logout {
    width: 311px;
    height: 46px;
    line-height: 46px;
    position: fixed;
    bottom: 36px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    background: #222222;
    border-radius: 23px;
    font-size: 15px;
    font-weight: bold;
    color: #ffffff;
  }
  .back {
    width: 311px;
    height: 46px;
    line-height: 46px;
    position: fixed;
    bottom: 100px;
    left: 32px;
    z-index: 10;
    background: #d6d6d6;
    border-radius: 23px;
    font-size: 15px;
    font-weight: bold;
    color: #222222;
  }
}
</style>
